import {REPORT_EARNED_ACCELERATOR_BONUS} from '/enum/records.enum';

export default {
  reportName: REPORT_EARNED_ACCELERATOR_BONUS,
};
